export const HOST = "https://test.ttechr.com/";

export const EXTERNAL_LINKS = {
  twitter: "https://twitter.com/HighScoreWM",
  instagram: "https://www.instagram.com/highscorewm/",
  discord: "https://discord.gg/tkP6mWkMt7",
};

export const IMGIX_HOST = "https://hswm.imgix.net/";
